import EditorVisualTextField from "developer/edit/components/EditorVisualTextField";
import useDynamicField from "developer/edit/hooks/useDynamicField";

type MaxFieldProps = {
  name: string;
  value: any;
  onChange: (value: any) => void;
};

const MaxField = (props: MaxFieldProps) => {
  const {
    input: { value: min },
  } = useDynamicField<number | undefined>("fieldDef.min");

  const handleChange = (e: any) => {
    const { value } = e.target;
    if (value && Number(value)) {
      props.onChange(Math.abs(Number(value)));
    } else if (!value) {
      props.onChange(null);
    }
  };

  const error = !!min && !!props.value && props.value < min;
  const helperText = error
    ? "Max must be equal or greater than Min"
    : undefined;

  return (
    <EditorVisualTextField
      id="max"
      size="small"
      label="Max"
      name={props.name}
      error={error}
      helperText={helperText}
      inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
      onChange={handleChange}
      value={props.value}
      fullWidth
    />
  );
};

export default MaxField;
